import {
  FORGOT_PASSWORD_FAIL,
  FORGOT_PASSWORD_OK,
  SET_NEW_PASSWORD_FAIL,
  SET_NEW_PASSWORD_OK
} from './actionTypes';

export const resetPassword = email => {
  return (dispatch, getState) => {
    const state = getState();
    return fetch('/api/auth/forgot-password', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': state.app.csrfToken
      },
      body: JSON.stringify({
        email
      })
    })
      .then(response => {
        if (response.ok) {
          dispatch({
            type: FORGOT_PASSWORD_OK
          });
        } else {
          return dispatch({
            type: FORGOT_PASSWORD_FAIL
          });
        }
      })
      .catch(() => {
        return dispatch({
          type: FORGOT_PASSWORD_FAIL
        });
      });
  };
};

export const setNewPassword = (token, newPassword) => (dispatch, getState) => {
  const state = getState();
  return fetch('/api/auth/reset-password', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': state.app.csrfToken
    },
    body: JSON.stringify({
      newPassword,
      token
    })
  })
    .then(response => {
      if (response.ok) {
        dispatch({
          type: SET_NEW_PASSWORD_OK
        });
      } else {
        return dispatch({
          type: SET_NEW_PASSWORD_FAIL
        });
      }
    })
    .catch(() => {
      return dispatch({
        type: SET_NEW_PASSWORD_FAIL
      });
    });
};


// WEBPACK FOOTER //
// ./src/store/resetPasswordActions.js